import React from 'react';
import { ReportDashboardKpis } from '../types';

interface Props {
  kpis: ReportDashboardKpis | null;
}

export const ReportsMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  const cards = [
    {
      title: 'Report Definitions',
      value: kpis.total_definitions,
      sub: 'Safety, Quality, Risk & Audit',
      color: '#0284c7',
    },
    {
      title: 'Monthly Execution Runs',
      value: kpis.total_runs_this_month,
      sub: 'On-Demand & Scheduled Executions',
      color: '#0d9488',
    },
    {
      title: 'Immutable Snapshots',
      value: kpis.immutable_snapshots_count,
      sub: 'Cryptographic Legal Evidence',
      color: '#16a34a',
    },
    {
      title: 'Regulatory Submissions',
      value: kpis.regulatory_submissions_count,
      sub: 'EASA / SHGM / ECCAIRS2 Filings',
      color: '#7c3aed',
    },
    {
      title: 'Active Schedules',
      value: kpis.active_schedules,
      sub: 'Automated Dispatch Timers',
      color: '#ea580c',
    },
    {
      title: 'Exported Files',
      value: kpis.exports_count,
      sub: 'PDF, XLSX & CSV Report Archive',
      color: '#2563eb',
    },
  ];

  return (
    <div className="stats-grid">
      {cards.map((c, i) => (
        <div key={i} className="stat-card">
          <span className="stat-label">{c.title}</span>
          <span className="stat-value" style={{ color: c.color }}>{c.value}</span>
          <span className="stat-sub">{c.sub}</span>
        </div>
      ))}
    </div>
  );
};
